import React, { useRef, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'; // Dodajemy hooki Reduxa

import { required } from '../../util/validators';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { featProductCatalog } from '../../ducks/productCatalog.duck'; // Importujemy Twoją akcję

import css from './EditListingDescriptionForm.css';
import FieldAutocompleteSelect from '../../components/FieldAutocompleteSelect/FieldAutocompleteSelect';

const AutocompleteProductSelectField = props => {
  const { id, intl, form, markRequired, disabled, selectedProduct, ...rest } = props;
  
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(featProductCatalog({ perPage: 300 }));
  }, [dispatch]);

  const rawCatalogProducts = useSelector(state => {
    const refs = state.productCatalog.productCatalog;
    return getMarketplaceEntities(state, refs);
  });
  const isFetching = useSelector(state => state.productCatalog.fetchInProgress);

  const catalogProducts = rawCatalogProducts.map(product => ({ 
    value: product.id.uuid, 
    label: `${product.attributes.modelCode} - ${product.attributes.title}` 
  }));

  const catalogProductLabel = intl.formatMessage({ id: 'EditListingDescriptionForm.catalogProductLabel' });
  const catalogProductPlaceholder = intl.formatMessage({ id: 'EditListingDescriptionForm.catalogProductPlaceholder' });
  const catalogProductRequired = intl.formatMessage({ id: 'EditListingDescriptionForm.catalogProductRequired' });

  const productRequired = () => value => {
    if (value?.label === '' && value?.value === '') return catalogProductRequired;
    if (typeof value?.value === 'undefined' || value?.value === null) return catalogProductRequired;
    return undefined;
  };
  const validate = productRequired();

  const debounceTimer = useRef(null);

  const handleInputChange = useCallback((phrase) => {
    if (debounceTimer.current) clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {
      if (phrase) {
        dispatch(featProductCatalog({ perPage: 100, phrase }));
      } else {
        dispatch(featProductCatalog({ perPage: 100 }));
      }
    }, 400);
  }, [dispatch]);

  const handleChange = (selectedOption) => {
    form.change('catalogProduct', selectedOption);
    form.change('catalogItem', '');
  };

  return (
    <FieldAutocompleteSelect
      className={css.category}
      id={id}
      label={catalogProductLabel}
      markRequired={markRequired}
      disabled={disabled}
      inputValue={selectedProduct}
      placeholder={catalogProductPlaceholder}
      options={catalogProducts}
      validate={validate}
      requiredProvider={catalogProductRequired}
      onChange={handleChange}
      onInputChange={handleInputChange} 
      isLoading={isFetching}
      {...rest}
    />
  );
};

export default AutocompleteProductSelectField;